import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSesion } from '../estado/SesionContext';
import { TarjetaCurso } from '../components/TarjetaCurso';
import type { ResumenCurso } from '../domain/types';

/**
 * La malla completa: los cursos que se pueden tomar Y los que vienen.
 *
 * Los bloqueados no son decorado — le dicen al recurso que su ruta sigue. Sin ellos, la
 * pantalla parece un catálogo de dos cursos y ya.
 */
export function Modulos() {
  const { repo, espacio, perfil } = useSesion();
  const [resumen, setResumen] = useState<ResumenCurso[] | null>(null);

  useEffect(() => {
    if (!repo) return;
    let vivo = true;
    void repo.listarResumen(espacio.id).then((r) => {
      if (vivo) setResumen(r);
    });
    return () => {
      vivo = false;
    };
  }, [repo, espacio.id]);

  const rolLegible = perfil?.roles.includes('coordinador') ? 'Coordinador' : 'Impulso';

  return (
    <div>
      <Link to="/" className="text-sm font-bold text-azul">
        ← Inicio
      </Link>

      <header className="mb-5 mt-3">
        <h1 className="font-titulos text-2xl font-extrabold">Módulos de aprendizaje</h1>
        <p className="text-sm text-gris">
          Tu malla: {rolLegible} · {espacio.cliente}
        </p>
      </header>

      {resumen === null ? (
        <p className="py-8 text-center text-gris">Cargando…</p>
      ) : resumen.length === 0 ? (
        <div className="rounded-2xl border border-borde bg-white p-8 text-center">
          <p className="text-3xl">📭</p>
          <p className="mt-3 font-extrabold">Todavía no tienes cursos asignados</p>
          <p className="mt-1 text-sm text-gris">
            Avisa a tu coordinador para que te habilite el acceso.
          </p>
        </div>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {resumen.map((r) => (
            <TarjetaCurso key={r.curso.id} resumen={r} />
          ))}
        </div>
      )}
    </div>
  );
}
